export const name = {
  name: 'name',
  displayName: 'Name',
  type: 'input',
  subType: '',
}

export const address = {
  name: 'address',
  displayName: 'Address',
  type: 'textarea',
}

export const email = {
  name: 'email',
  displayName: 'Business Email',
  type: 'input',
}

export const phoneNumber = {
  name: 'phoneNumber',
  displayName: 'Phone Number',
  type: 'input',
}

export const website = {
  name: 'website',
  displayName: 'Website',
  type: 'input',
}

export const company = {
  name: 'company',
  displayName: 'Company',
  type: 'input',
}

export const compliance = {
  name: 'complianceCheckBox',
  displayName: 'Compliance Text',
  type: 'checkbox',
}

export const taxExemptionEligibility = {
  name: 'taxExemptionEligibility',
  displayName: 'Is your business eligible for tax exemption?',
  type: 'dropdown',
  infoType: 'details',
  entries: [
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ],
}

export const taxIdNumber = {
  name: 'taxIdNumber',
  displayName: 'Tax ID# (if eligible for exemption)',
  type: 'input',
  infoType: 'details',
}

export const sourceOfInformation = {
  name: 'sourceOfInformation',
  displayName: 'How did you hear about this program?',
  type: 'dropdown',
  infoType: 'details',
  entries: [
    {
      label: 'Referral',
      value: 'Referral',
    },
    {
      label: 'Browsing Quince.com',
      value: 'Browsing Quince.com',
    },
    {
      label: 'Google',
      value: 'Google',
    },
    {
      label: 'Facebook',
      value: 'Facebook',
    },
    {
      label: 'Instagram',
      value: 'Instagram',
    },
    {
      label: 'LinkedIn',
      value: 'LinkedIn',
    },
  ],
}
